"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Forms/FormStatusChip.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _forms = require('shared/services/forms');
require('./formsChat.scss');

const ICONS = { sent: 'send', progress: 'edit', done: 'check', expired: 'schedule' } 



/* Sent, In progress (with its rows where asked), Completed {date}, Expired {date}. */
const FormStatusChip = ({ card, withRows, className }) => {
  const { tone, label } = _forms.statusChip.call(void 0, card, withRows)
  return (
    _react2.default.createElement('span', { className: _classBuilder2.default.call(void 0, 'forms-state-chip', `forms-state-chip--${tone}`, className), __self: this, __source: {fileName: _jsxFileName, lineNumber: 15}}
      , _react2.default.createElement('i', { className: "material-icons forms-state-chip--icon" , 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 16}}, ICONS[tone])
      , label
    )
  )
}

exports. default = FormStatusChip
